<template>
    <Header />
    <Address ref="addressRef" />
</template>

<script setup>
import { storeToRefs } from "pinia";
import { ref, onMounted, provide } from "vue";
import { GetMyInfo } from "./api";
import { useUser } from "./store/store";
import Header from "./components/header";
import Address from "./components/address";

const { user } = storeToRefs(useUser());
const addressRef = ref(null);

onMounted(async () => {
    await getMyInfo();
});

// 个人信息获取
const getMyInfo = async () => {
    const res = await GetMyInfo();
    if (res) {
        user.value = res;
        // 未登录
        if (!res.login_account) {
            addressRef.value.Enter();
            return sdoLogin();
        }
        // 无权限
        if (res.login_account && res.auth == 0) {
            addressRef.value.Enter();
            return CsLib.alert("当前未查询到中奖信息", 3200, "error");
        }
        // 登录未填
        if (res.login_account && res.auth == 1 && !res.data.address) {
            return addressRef.value.Enter();
        }
        // 登录已填
        if (res.login_account && res.data.address) {
            addressRef.value.Detail(res.data);
        }
    }
};

provide("addressRef", addressRef);
</script>

<style lang="scss" scoped></style>
